import React, { useState } from 'react';
import { Tooltip } from 'antd';
import { CodeBlock, CopyCodeIcon, CopiedCheckIcon } from '../Styles';

const CopyableCode: React.FC<{ value: string }> = ({ value }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <CodeBlock>
      <span style={{ flex: 1, wordBreak: 'break-all' }}>{value}</span>
      <Tooltip title={copied ? 'Copied!' : 'Copy'}>
        {copied ? (
          <CopiedCheckIcon />
        ) : (
          <CopyCodeIcon onClick={handleCopy} />
        )}
      </Tooltip>
    </CodeBlock>
  );
};

export default CopyableCode;
